import { render, staticRenderFns } from "./ChannelPopover.vue?vue&type=template&id=794f11d9"
import script from "./ChannelPopover.vue?vue&type=script&lang=js"
export * from "./ChannelPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports